/**
 * フォーカス表示管理クラス
 * マウス操作時のフォーカス表示を抑制し、キーボード操作時のみフォーカスを表示する
 */
export default class FocusVisibleManager {
  private static instance: FocusVisibleManager | null = null;
  private isKeyboardUser: boolean = false;
  private lastInteractionWasKeyboard: boolean = false;

  private constructor() {
    this.init();
  }

  public static getInstance(): FocusVisibleManager {
    if (!FocusVisibleManager.instance) {
      FocusVisibleManager.instance = new FocusVisibleManager();
    }
    return FocusVisibleManager.instance;
  }

  private init(): void {
    // キーボード操作の検出
    document.addEventListener('keydown', this.onKeyDown.bind(this), true);
    
    // マウス操作の検出
    document.addEventListener('mousedown', this.onMouseDown.bind(this), true);
    document.addEventListener('pointerdown', this.onPointerDown.bind(this), true);
    
    // フォーカスイベントの管理
    document.addEventListener('focusin', this.onFocusIn.bind(this), true);
    document.addEventListener('focusout', this.onFocusOut.bind(this), true);
  }

  private onKeyDown(event: KeyboardEvent): void {
    // Tab, Shift+Tab, 矢印キー、Enter, Spaceキーなどのナビゲーションキー
    if (this.isNavigationKey(event)) {
      this.isKeyboardUser = true;
      this.lastInteractionWasKeyboard = true;
      document.body.classList.add('keyboard-user');
      document.body.classList.remove('mouse-user');
    }
  }

  private onMouseDown(event: MouseEvent): void {
    this.isKeyboardUser = false;
    this.lastInteractionWasKeyboard = false;
    document.body.classList.add('mouse-user');
    document.body.classList.remove('keyboard-user');
  }

  private onPointerDown(event: PointerEvent): void {
    if (event.pointerType === 'mouse') {
      this.onMouseDown(event as unknown as MouseEvent);
    }
  }

  private onFocusIn(event: FocusEvent): void {
    const target = event.target as HTMLElement;
    
    // マウス操作直後のフォーカスの場合は、フォーカス表示を抑制
    if (!this.lastInteractionWasKeyboard) {
      target.classList.add('no-focus-visible');
    } else {
      target.classList.remove('no-focus-visible');
    }
  }

  private onFocusOut(event: FocusEvent): void {
    const target = event.target as HTMLElement;
    target.classList.remove('no-focus-visible');
  }

  private isNavigationKey(event: KeyboardEvent): boolean {
    const navigationKeys = [
      'Tab',
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'Enter',
      ' ', // Space
      'Escape',
      'Home',
      'End',
      'PageUp',
      'PageDown'
    ];
    
    return navigationKeys.includes(event.key);
  }

  public isKeyboardUserActive(): boolean {
    return this.isKeyboardUser;
  }

  public wasLastInteractionKeyboard(): boolean {
    return this.lastInteractionWasKeyboard;
  }
}